var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcNewLinkV216Light(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7505 1.875C15.1295 1.875 14.6255 2.379 14.6255 3C14.6255 3.621 15.1295 4.125 15.7505 4.125H18.2876L11.3179 11.0918C10.8784 11.5313 10.8784 12.2431 11.3179 12.6826C11.7574 13.1221 12.4692 13.1221 12.9087 12.6826L19.8755 5.71289V8.25C19.8755 8.871 20.3795 9.375 21.0005 9.375C21.6215 9.375 22.1255 8.871 22.1255 8.25V3C22.1255 2.85258 22.0952 2.70457 22.0376 2.56641V2.56348C21.9807 2.4289 21.8963 2.30787 21.7945 2.20605C21.6882 2.09939 21.568 2.01778 21.437 1.96289H21.4341C21.296 1.90532 21.1479 1.875 21.0005 1.875H15.7505Z",
    fill: "#F2AE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 1.875C3.804 1.875 3.13751 2.15201 2.64551 2.64551C2.15201 3.13751 1.875 3.804 1.875 4.5V19.5C1.875 20.196 2.15201 20.8625 2.64551 21.3545C3.13751 21.848 3.804 22.125 4.5 22.125H19.5C20.196 22.125 20.8625 21.848 21.3545 21.3545C21.848 20.8625 22.125 20.196 22.125 19.5V14.25C22.125 13.629 21.621 13.125 21 13.125C20.379 13.125 19.875 13.629 19.875 14.25V19.5C19.875 19.599 19.8371 19.6961 19.7666 19.7666C19.6961 19.8371 19.599 19.875 19.5 19.875H4.5C4.401 19.875 4.3039 19.8371 4.2334 19.7666C4.1629 19.6961 4.125 19.599 4.125 19.5V4.5C4.125 4.401 4.1629 4.3039 4.2334 4.2334C4.3039 4.1629 4.401 4.125 4.5 4.125H9.75C10.371 4.125 10.875 3.621 10.875 3C10.875 2.379 10.371 1.875 9.75 1.875H4.5Z",
    fill: "#02B37F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNewLinkV216Light);
export default __webpack_public_path__ + "static/media/ic_new_link_v2_16_light.9b56567380861705bc2559aa5a218797.svg";
export { ForwardRef as ReactComponent };